/* Shared cart snapshots and an ordered lane for the store's optional add-ons. */
(function (window, document) {
  'use strict';
  var api = window.GBCart;
  if (!api || api.readCart) return;
  var cart = null, addonState = null, stateNode = null, revision = 0;
  var readPromise = null, mutationTail = Promise.resolve(), listeners = [];
  var mutationEpoch = 0, readEpoch = -1, readRevision = -1;
  var notificationQueued = false, eventTimer = null, eventRevision = 0;
  function lineProperties(value) {
    return Array.isArray(value) ? Object.fromEntries(value.filter(function (entry) { return Array.isArray(entry) && entry.length === 2; })) : value || {};
  }

  function notify() {
    if (notificationQueued) return;
    notificationQueued = true;
    Promise.resolve().then(function () {
      notificationQueued = false;
      listeners.slice().forEach(function (listener) {
        try { listener(cart); } catch (error) { console.warn('[GBCart] listener', error); }
      });
    });
  }
  function fromAddonState(state) {
    return {
      attributes: state.attributes || {}, currency: state.currency,
      total_price: state.totalPrice,
      item_count: state.itemCount,
      items: (state.lines || []).map(function (line) {
        var net = Number(line.originalLinePrice || 0);
        (line.discountAllocations || []).forEach(function (amount) { net -= Number(amount || 0); });
        return {
          key: line.key, variant_id: line.variantId, product_id: line.productId,
          handle: line.handle, title: line.title, product_title: line.title,
          quantity: line.quantity, properties: lineProperties(line.properties),
          requires_shipping: line.requiresShipping,
          original_line_price: line.originalLinePrice, final_line_price: net,
          final_price: line.quantity ? net / line.quantity : 0,
          selling_plan_allocation: line.sellingPlanId ? { selling_plan: { id: line.sellingPlanId } } : null
        };
      })
    };
  }
  function consumeDOM() {
    var node = document.querySelector('[data-gb-cart-state] [data-gb-addon-state]');
    if (!node || node === stateNode) return false;
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      if (!Array.isArray(parsed.lines)) return false;
      stateNode = node; addonState = parsed; cart = fromAddonState(parsed);
      revision += 1; notify(); return true;
    } catch (error) { return false; }
  }
  api.readCart = function (force) {
    consumeDOM();
    if (cart && !force) return Promise.resolve(cart);
    if (readPromise && readEpoch === mutationEpoch && readRevision === revision) return readPromise;
    var startedAt = revision, startedEpoch = mutationEpoch, request;
    readEpoch = startedEpoch; readRevision = startedAt;
    // One retry when the store says 429 (too many requests) or 503: a read changes nothing, so it is always safe (2026-11-04).
    function get(retried) {
      return window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!retried && (response.status === 429 || response.status === 503)) {
            return new Promise(function (resolve) { setTimeout(resolve, 1200); }).then(function () { return get(true); });
          }
          if (!response.ok) throw new Error('Cart read failed (' + response.status + ')');
          return response.json();
        });
    }
    request = get(false)
      .then(function (fresh) {
        consumeDOM();
        if (revision === startedAt && mutationEpoch === startedEpoch) { cart = fresh; revision += 1; eventRevision = revision; notify(); }
        return force ? fresh : cart;
      }).finally(function () { if (readPromise === request) readPromise = null; });
    readPromise = request;
    return request;
  };
  api.commitCart = function (fresh, announce) {
    if (!fresh || !Array.isArray(fresh.items)) return;
    cart = fresh; revision += 1; eventRevision = revision; notify();
    if (announce) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'gb-cart-state', cart: fresh } }));
  };
  api.addonState = function () { consumeDOM(); return addonState; };
  api.subscribe = function (listener) {
    listeners.push(listener);
    return function () { listeners = listeners.filter(function (value) { return value !== listener; }); };
  };
  api.queueMutation = function (task) {
    function run() { mutationEpoch += 1; return task(); }
    var result = mutationTail.then(run, run);
    mutationTail = result.catch(function () {});
    return result;
  };
  api.whenIdle = function () { return mutationTail; };
  var applyDrawer = api.applyDrawer;
  api.applyDrawer = function (sections) {
    consumeDOM();
    var focused = document.activeElement, focusLine = null;
    var focusRow = focused && focused.closest && focused.closest('[id^="CartDrawer-Item-"]');
    if (focusRow && addonState) focusLine = addonState.lines[Number(focusRow.id.replace('CartDrawer-Item-', '')) - 1];
    var focusName = focused && focused.getAttribute && focused.getAttribute('name');
    var focusWrap = focused && focused.closest && focused.closest('[data-gb-addon-wrap-card]');
    var result = applyDrawer.call(api, sections);
    consumeDOM();
    if (result && focused && !focused.isConnected && document.activeElement === document.body) {
      var target = null;
      if (focusWrap) target = document.querySelector('[data-gb-wrap-switch]');
      else if (focusLine && focusName && addonState && window.GBCartQuantity) {
        var match = window.GBCartQuantity.locate(addonState.lines, focusLine);
        var row = match && document.getElementById('CartDrawer-Item-' + (addonState.lines.indexOf(match) + 1));
        if (row) target = Array.from(row.querySelectorAll('[name]')).find(function (element) { return element.getAttribute('name') === focusName; });
      }
      if (target && !target.disabled) { try { target.focus({ preventScroll: true }); } catch (error) {} }
    }
    return result;
  };
  var drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(function () { consumeDOM(); })
    .observe(drawer, { childList: true, subtree: true });
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:build', 'cart:added', 'cartQuantityUpdated'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      // Shrine's native cart page emits this event after replacing
      // #main-cart-items. The drawer quantity bridge emits the same marker
      // after it has already committed its response, so only the cart page
      // needs the extra canonical read.
      if (name === 'cartQuantityUpdated' && !document.getElementById('main-cart-items')) return;
      if (event.detail && event.detail.source === 'gb-dynamic-addons') return;
      if (event.detail && event.detail.cart) return;
      if (eventTimer != null) return;
      eventTimer = window.setTimeout(function () {
        eventTimer = null;
        consumeDOM();
        if (eventRevision !== revision) { eventRevision = revision; return; }
        api.readCart(true).catch(function () {});
      }, 0);
    });
  });
  consumeDOM();
  eventRevision = revision;
  document.dispatchEvent(new CustomEvent('gb:cart-ready'));
})(window, document);
